import { Grid, IconButton, InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { changePassword } from '@webapps/business';
import {
  Button,
  Modal,
  FormikTextField,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Row from 'components/Form/Row';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const updatePasswordSchema = yup.object().shape({
  currentPassword: yup
    .string()
    .required('Requis')
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d\s\W]{8,128}$/,
      'Le mot de passe doit contenir au minimum 8 caractères, une majuscule, une minuscule et un chiffre .'
    ),
  newPassword: yup
    .string()
    .required('Requis')
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d\s\W]{8,128}$/,
      'Le mot de passe doit contenir au minimum 8 caractères, une majuscule, une minuscule et un chiffre .'
    ),
  repeatNewPassword: yup
    .string()
    .required('Requis')
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d\s\W]{8,128}$/,
      'Le mot de passe doit contenir au minimum 8 caractères, une majuscule, une minuscule et un chiffre .'
    ),
});

const PasswordUpdate = () => {
  const {
    css,
    classes,
    theme: { spacing },
  } = useStyles(styles);

  const [error, setError] = useState(false);

  const {
    error: errorRequest,
    isLoading: isLoadingUpdate,
    isSuccess,
    mutateAsync: mutateChangePassword,
  } = useMutation(changePassword);

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
    }
  }, [isSuccess]);

  const formik = useFormik({
    initialValues: {
      currentPassword: '',
      newPassword: '',
      repeatNewPassword: '',
    },
    validationSchema: updatePasswordSchema,
    onSubmit: async ({ currentPassword, newPassword, repeatNewPassword }) => {
      if (newPassword === repeatNewPassword) {
        await mutateChangePassword({
          oldPassword: currentPassword,
          newPassword,
        });
      } else {
        setError(true);
      }
    },
  });

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const [showPassword1, setShowPassword1] = useState(false);
  const handleClickShowPassword1 = () => setShowPassword1(!showPassword1);
  const handleMouseDownPassword1 = () => setShowPassword1(!showPassword1);

  const [showPassword2, setShowPassword2] = useState(false);
  const handleClickShowPassword2 = () => setShowPassword2(!showPassword2);
  const handleMouseDownPassword2 = () => setShowPassword2(!showPassword2);

  return (
    <div>
      <Row>
        <Grid container spacing={2} style={{ marginTop: spacing(0.5), marginLeft: spacing(0.5) }}>
          <Grid container spacing={2} >
            <Grid item xs={12} className={css({ width: '96%', flexBasis: '96%' })}>
              <FormikTextField
                formik={formik}
                fullWidth
                borderRadius={6}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? (
                          <Visibility fontSize="small" />
                        ) : (
                          <VisibilityOff fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                label={
                  <FormattedMessage id="student.settings.subMenu.security.item.password.currentPassword" />
                }
                name="currentPassword"
                type={showPassword ? 'text' : 'password'}
                variant='outlined'
              />
            </Grid>
            <Grid item xs={12} className={css({ width: '96%', flexBasis: '96%' })}>
              <FormikTextField
                formik={formik}
                fullWidth
                borderRadius={6}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword1}
                        onMouseDown={handleMouseDownPassword1}
                      >
                        {showPassword1 ? (
                          <Visibility fontSize="small" />
                        ) : (
                          <VisibilityOff fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                label={
                  <FormattedMessage id="student.settings.subMenu.security.item.password.newPassword" />
                }
                name="newPassword"
                type={showPassword1 ? 'text' : 'password'}
                variant='outlined'
              />
            </Grid>
            <Grid item xs={12} className={css({ width: '96%', flexBasis: '96%' })}>
              <FormikTextField
                formik={formik}
                fullWidth
                borderRadius={6}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword2}
                        onMouseDown={handleMouseDownPassword2}
                      >
                        {showPassword2 ? (
                          <Visibility fontSize="small" />
                        ) : (
                          <VisibilityOff fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                label={
                  <FormattedMessage id="student.settings.subMenu.security.item.password.repeatNewPassword" />
                }
                name="repeatNewPassword"
                type={showPassword2 ? 'text' : 'password'}
                variant='outlined'
              />
            </Grid>
            <Grid item xs={6} className={css({ width: '48%', flexBasis: '48%' })}>
              { formik?.values?.currentPassword && (
                <Button
                  className={css({ borderRadius: '10.0px' })}
                  color="primary"
                  disabled={isLoadingUpdate}
                  onClick={formik.handleSubmit}
                  variant="contained"
                >
                  <FormattedMessage id="vitrine.btnCreate" />
                </Button>
              )}
            </Grid>
            <Grid item xs={6} className={css({ width: '48%', flexBasis: '48%' })}>
            </Grid>
          </Grid>
        </Grid>
        {error && !isSuccess && (
          <div className={css({ color: 'red', marginTop: spacing(1.5) })}>
            Les mots de passe doivent être identique
          </div>
        )}
        {errorRequest?.code === 'NotAuthorizedException' && (
          <div
            className={css({
              flex: '1 0 auto',
              marginTop: spacing(1.5),
              color: 'red',
            })}
          >
            Mot de passe incorrect
          </div>
        )}
        {errorRequest?.code === 'LimitExceededException' && !isSuccess && (
          <div
            className={css({
              flex: '1 0 auto',
              marginTop: spacing(1.5),
              color: 'red',
            })}
          >
            Limite de tentative dépassée, veuillez essayer après un certain
            temps.
          </div>
        )}
      </Row>
    </div>
  );
};

const styles = ({ spacing }) => ({
  btnDelete: {
    float: 'right',
    backgroundColor: 'crimson',
  },
  deleteAccount: {
    textAlign: 'center',
    marginBottom: '16px',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  }
});

export default PasswordUpdate;
